import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Login.css';

const Sidebar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenuClick = (menu) => {
    switch(menu) {
      case 'KAS':
        // Toggle: if on KAS page, go to home, else go to KAS
        if (location.pathname === '/kas/cardbit') {
          setActiveMenu(null);
          navigate('/home');
        } else {
          setActiveMenu('KAS');
          navigate('/kas/cardbit');
        }
        break;
      case 'INF':
        setActiveMenu('INF');
        console.log('INF not implemented yet');
        navigate('/home');
        break;
      case 'KEC':
        setActiveMenu('KEC');
        console.log('KEC not implemented yet');
        navigate('/home');
        break;
      case 'KDS':
        setActiveMenu('KDS');
        console.log('KDS not implemented yet');
        navigate('/home');
        break;
      default:
        setActiveMenu(null);
        navigate('/home');
    }
  };

  // Update active state based on route
  useEffect(() => {
    if (location.pathname === '/kas/cardbit') {
      setActiveMenu('KAS');
    } else if (location.pathname === '/home') {
      setActiveMenu(null);
    }
  }, [location.pathname]);

  return (
    <div className="sidebar">
      <div className="menu-items">
        <div 
          className={`menu-item ${activeMenu === 'KAS' ? 'active' : ''}`}
          onClick={() => handleMenuClick('KAS')}
        >
          KAS
        </div>
        <div 
          className={`menu-item ${activeMenu === 'INF' ? 'active' : ''}`}
          onClick={() => handleMenuClick('INF')}
        >
          INF
        </div>
        <div 
          className={`menu-item ${activeMenu === 'KEC' ? 'active' : ''}`}
          onClick={() => handleMenuClick('KEC')}
        >
          KEC
        </div>
        <div 
          className={`menu-item ${activeMenu === 'KDS' ? 'active' : ''}`}
          onClick={() => handleMenuClick('KDS')}
        >
          KDS
        </div>
      </div>
    </div>
  );
};

export default Sidebar;